import { useEffect, useState } from "react";
import { Card } from "./../../components/card/card.jsx";
import { Link } from "react-router-dom";
import { otherActivityList } from "../../config/apiSPA.js";
import DateFormat from "../../components/dateFormater/dateFormat1.js";
import Pagination3 from "../../components/pagination/pagination3.jsx";

const trainingPresetData = {
  current_page: 1,
  data: [],
  last_page: 1,
  from: 1,
  path: null,
  to: 0,
  total: 0,
};

function OtherActivity() {
  const [dataList, setDataList] = useState({ data: [], links: {}, meta: {}, status: null });
  const [search1Value, setSearch1Value] = useState("");

  function nextClick1() {
    if (dataList.meta.current_page < dataList.meta.last_page) otherActivityList(search1Value, dataList.meta.current_page + 1).then((res) => setDataList(res));
  }
  function prevClick1() {
    if (dataList.meta.current_page > 0) otherActivityList(search1Value, dataList.meta.current_page - 1).then((res) => setDataList(res));
  }
  function submitSearch1(e) {
    e.preventDefault();
    otherActivityList(search1Value).then((res) => setDataList(res));
  }

  useEffect(() => {
    otherActivityList().then((res) => {
      setDataList(res);
    });
  }, []);

  return (
    <>
      <div>
        <div className="d-flex align-items-center mb-3">
          <div>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#/">Other Activity</a>
              </li>
              <li className="breadcrumb-item active">Data</li>
            </ul>

            <h1 className="page-header">
              Other Activity Data <small></small>
            </h1>
          </div>

          <div className="ms-auto">
            <Link to="/other-activity/new" className="btn btn-outline-theme">
              <i className="fa fa-plus-circle fa-fw me-1"></i> Input Activity
            </Link>
          </div>
        </div>

        <hr className="mb-1" />
        <div className="p-2">
          <p>
            <strong>Other Activity</strong> refers to tasks performed outside the main activities (training and mentoring). This entry is limited to <span className="text-theme">one submission per day</span> and cannot be duplicated.
          </p>
        </div>

        <Card>
          <div className="tab-content p-4">
            {/* ----------------All Tab------------------------------------------------------------------ */}
            <div className="tab-pane fade show active" id="allTab">
              <form onSubmit={(e) => submitSearch1(e)}>
                <div className="input-group mb-4">
                  <div className="d-flex justify-content-end">
                    <div className="input-group">
                      <input type="text" onChange={(e) => setSearch1Value(e.target.value)} className="form-control px-35px" placeholder="Search" />
                      <div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0" style={{ zIndex: 1020 }}>
                        <i className="fa fa-search opacity-5"></i>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-outline-default" type="submit">
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </form>

              {/* ----------------Table-------------- */}

              <div className="table-responsive">
                <table className="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th className="border-top-0 pt-0 pb-2"></th>
                      <th className="border-top-0 pt-0 pb-2">Activity</th>
                      <th className="border-top-0 pt-0 pb-2">Instructor</th>
                      <th className="border-top-0 pt-0 pb-2">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataList.data.length > 0 ? (
                      dataList.data.map((val) => (
                        <tr key={val.id}>
                          <td className="align-middle">{val.evident.length > 0 ? "" : <i title="No Evident" className="fas fa-exclamation-triangle text-danger"></i>}</td>
                          <td className="align-middle">
                            <Link to={`/other-activity/detail/${val.id}`}>{val.activity}</Link>
                          </td>

                          <td className="align-middle">{val.instructor}</td>
                          <td className="align-middle">{DateFormat(val.date)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr></tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* ----------------End Table-------------- */}
              {dataList.data.length ? <Pagination3 pageInfo={dataList} nextClick={nextClick1} prevClick={prevClick1} /> : ""}
            </div>
            {/* ----------------End All Tab------------------------------------------------------------------ */}
          </div>
        </Card>
      </div>
    </>
  );
}

export default OtherActivity;
